import { combineReducers } from 'redux';
import { BET_RECORD_KEY, betRecordSliceReducer } from './betRecord';
import { BET_STATISTICS_KEY, betStatisticsSliceReducer } from './betStatistics';
import { BET_SUMMARY_KEY, betSummarySliceReducer } from './betSummary';
import {
    BET_FAIL_SUMMARY_KEY,
    betFailSummarySliceReducer,
} from './betFailSummary';
import { GIFT_RECORD_KEY, giftRecordSliceReducer } from './giftRecord';
const reportReducer = combineReducers({
    [BET_SUMMARY_KEY]: betSummarySliceReducer,
    [BET_RECORD_KEY]: betRecordSliceReducer,
    [BET_STATISTICS_KEY]: betStatisticsSliceReducer,
    [BET_FAIL_SUMMARY_KEY]: betFailSummarySliceReducer,
    [GIFT_RECORD_KEY]: giftRecordSliceReducer,
});
export default reportReducer;
export type ReportState = ReturnType<typeof reportReducer>;
export const REPORT_KEY = 'app::report';
